import _ from 'lodash'

const DEFAULTS = {
  DECIMAL_PLACES: {
    FROM: 2,
    TO: 4,
  },
} as const

export const floatPercentFromDTO = (
  num: number,
  decimalPlaces: number = DEFAULTS.DECIMAL_PLACES.FROM,
): number => parseFloat(_.round(num * 100, decimalPlaces * 2).toFixed(decimalPlaces))

export const floatPercentToDTO = (
  num: number,
  decimalPlaces: number = DEFAULTS.DECIMAL_PLACES.TO,
): number => parseFloat(_.round(num / 100, decimalPlaces * 2).toFixed(decimalPlaces))

export const millisecondsToSeconds = (num: number): number => num / 1000
export const secondsToMilliseconds = (num: number): number => num * 1000
export const millisecondsToMinutes = (num: number): number => num / (1000 * 60)
export const minutesToMilliseconds = (num: number): number => num * (1000 * 60)
